/* ==========================================================================
   CalendarRxjs > Template
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');

const ViewHelpers = require('@bluekiri/alexandria/core/ViewHelpers');
const { prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');

const configuration = require('./client/js/config');

/* Exports */
module.exports = function Template(data = {}, context = {}) {
    /* Data */
    const {
        config = {},
        label,
        icon,
        title,
        name,
        content,
        placeholder,
        minDate = null,
        maxDate = null,
        startDate = null,
        endDate = null,
        minTime = null,
        maxTime = null,
        disable = []
    } = data;
    const { styles = [] } = config;
    const { dataType } = prepareDataConfig(config.data);

    /* Config */
    const { isAlternative = false, hasClear = false, mode = 'range' } = config;

    /* Template */
    return html(`
        <div class='${['input-rxjs', 'calendar-rxjs', isAlternative ? configuration().css.alternative : '', ...styles]
            .join(' ')
            .trim('')}'
            data-component='${configuration().component}'
            ${dataType ? `data-type='${dataType}'` : ''}
            data-config='${JSON.stringify({
                ...config,
                mode,
                context,
                hasClear,
                startDate,
                endDate,
                minDate,
                maxDate,
                minTime,
                maxTime,
                disable
            })}'>
        
            ${label ? `<label>${label}</label>` : ''}
            ${icon ? ViewHelpers(context).icon(icon) : ''}

            <input type='text'
                ${title ? `title='${title}'` : ''}
                ${name ? `name='${name}'` : ''}
                ${content ? `content='${content}'` : ''}
                ${isAlternative ? `placeholder='${placeholder}'` : ''}>
        </div>
    `);
};
